export default "__VITE_ASSET__LVtS9xH0__"